import React, { useState, lazy } from 'react';
export function Reason2() {
  const [usageFrequency, setUsageFrequency] = useState(3);
  const medications = [{
    name: 'Sumatriptan prescriptions',
    cost: 2847
  }, {
    name: 'Quarterly Botox',
    cost: 4200
  }, {
    name: 'Massage therapy',
    cost: 3600
  }, {
    name: 'Acupuncture attempts',
    cost: 2400
  }, {
    name: 'Neurologist consultation',
    cost: 850
  }];
  const totalCost = medications.reduce((sum, med) => sum + med.cost, 0);
  const maxCost = Math.max(...medications.map(med => med.cost));
  return <div className="py-12 border-t border-[#F1F5F9]" data-id="element-271">
      <div className="flex flex-col md:flex-row md:gap-8" data-id="element-272">
        <div className="md:w-2/3" data-id="element-273">
          <div className="flex items-center mb-4" data-id="element-274">
            <div className="bg-[#0EA5B7] text-white font-bold rounded-full w-10 h-10 flex items-center justify-center mr-4" data-id="element-275">
              2
            </div>
            <h2 className="text-2xl font-bold text-[#0F172A]" data-id="element-276">Reason #2:</h2>
          </div>
          <h3 className="text-xl font-semibold text-[#0F172A] mb-6" data-id="element-277">
            The $8,500 Medication Trap That's Keeping You Sick (Plus The FDA
            Warning Your Pharmacist Won't Mention)
          </h3>
          <div className="mb-8" data-id="element-278">
            <picture data-id="element-279">
              <source srcSet="https://uploadthingy.s3.us-west-1.amazonaws.com/jLmRu3L2boCGvASW8PJFvy/ChatGPT_Image_Sep_20%2C_2025%2C_06_35_17_PM.webp" type="image/webp" data-id="element-280" />
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jLmRu3L2boCGvASW8PJFvy/ChatGPT_Image_Sep_20%2C_2025%2C_06_35_17_PM.webp" alt="Comparison showing expensive medication costs vs iRelief Oculis-3 solution" className="w-full rounded-lg shadow-md" width="800" height="450" loading="lazy" data-id="element-281" />
            </picture>
          </div>
          <div className="prose prose-slate max-w-none" data-id="element-282">
            <p data-id="element-283">Three Imitrex in one week.</p>
            <p data-id="element-284">
              That's all it took to transform my occasional migraines into daily
              torture.
            </p>
            <p data-id="element-285">
              Nobody warned me about Medication Overuse Headaches. Not my
              neurologist who prescribed them. Not the pharmacist who filled
              them. Not even the insert with its 47 listed side effects.
            </p>
            <p data-id="element-286">
              It wasn't until I found a buried FDA report that I learned the
              truth:{' '}
              <strong data-id="element-287">
                Taking triptans more than 2-3 times weekly actually CAUSES more
                headaches.
              </strong>{' '}
              They call it "rebound" — your brain becomes dependent on the
              medication, then punishes you with worse pain when it wears off.
            </p>
            <p data-id="element-288">The numbers are staggering:</p>
            <ul className="list-disc pl-6 space-y-2 my-4" data-id="element-289">
              <li data-id="element-290">
                Average annual out-of-pocket cost for chronic migraine patients:
                $8,500-$9,500
              </li>
              <li data-id="element-291">Dihydroergotamine: $745.99 per prescription</li>
              <li data-id="element-292">Lasmiditan: $661.28 per dose</li>
              <li data-id="element-293">
                CGRP inhibitors: $600+ monthly (if insurance denies you, which
                they usually do)
              </li>
            </ul>
            <p data-id="element-294">But cost isn't even the worst part.</p>
            <p data-id="element-295">
              I found a post from someone who'd been on Aimovig:{' '}
              <em data-id="element-296">
                "I was living in a constant state of intractable migraines, #10.
                Not only did I see my migraines increasing in numbers, the
                intensity increased severely."
              </em>
            </p>
            <p data-id="element-297">
              Think about that. The medication designed to prevent migraines was
              creating worse ones.
            </p>
            <p data-id="element-298">
              And those "safe" over-the-counter options? NSAIDs carry FDA black
              box warnings for gastrointestinal bleeding and cardiovascular
              risks. Use them more than 10-15 days monthly, and — you guessed it
              — rebound headaches.
            </p>
            <p data-id="element-299">
              We're not patients. We're subscribers. Locked into a monthly
              payment plan for temporary relief that creates permanent
              dependence.
            </p>
            <p data-id="element-300">
              The iRelief Oculis-3 broke my medication cycle in 6 weeks. Zero
              pills since October 15th 2024. But it's HOW it works that's the
              real breakthrough...
            </p>
          </div>
        </div>
        <div className="md:w-1/3 mt-8 md:mt-0" data-id="element-301">
          <div className="bg-white rounded-lg shadow-sm border border-[#F1F5F9] p-4 mb-6" data-id="element-302">
            <h4 className="font-medium text-[#0F172A] mb-4" data-id="element-303">
              Medication Usage Awareness
            </h4>
            <div className="mb-2 flex justify-between text-xs text-[#334155]" data-id="element-304">
              <span data-id="element-305">Safe</span>
              <span data-id="element-306">Risky</span>
              <span data-id="element-307">Dangerous</span>
            </div>
            <div className="h-4 bg-gradient-to-r from-green-100 via-yellow-100 to-red-100 rounded-full mb-1 relative" data-id="element-308">
              <div className="absolute top-0 bottom-0 w-1 bg-[#0F172A] rounded-full transform -translate-x-1/2 transition-all duration-300" style={{
              left: `${usageFrequency / 10 * 100}%`
            }} data-id="element-309" />
            </div>
            <div className="flex justify-between text-xs text-[#334155] mb-4" data-id="element-310">
              <span data-id="element-311">0</span>
              <span data-id="element-312">5</span>
              <span data-id="element-313">10+</span>
            </div>
            <div className="mb-4" data-id="element-314">
              <label className="block text-sm font-medium text-[#334155] mb-1" data-id="element-315">
                Medication days per month: {usageFrequency}
              </label>
              <input type="range" min="0" max="10" value={usageFrequency} onChange={e => setUsageFrequency(parseInt(e.target.value))} className="w-full h-2 bg-[#F1F5F9] rounded-lg appearance-none cursor-pointer" data-id="element-316" />
            </div>
            <div className={`text-sm p-3 rounded-md ${usageFrequency <= 2 ? 'bg-green-50 text-green-800' : usageFrequency <= 5 ? 'bg-yellow-50 text-yellow-800' : 'bg-red-50 text-red-800'}`} data-id="element-317">
              {usageFrequency <= 2 ? 'Low risk of medication overuse headaches.' : usageFrequency <= 5 ? 'Moderate risk of rebound headaches.' : 'High risk of medication dependence and worsening symptoms.'}
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-[#F1F5F9] p-4" data-id="element-318">
            <h4 className="font-medium text-[#0F172A] mb-4" data-id="element-319">
              Annual Cost Comparison
            </h4>
            <div className="space-y-3" data-id="element-320">
              {medications.map((med, index) => <div key={index} data-id="element-321">
                  <div className="flex justify-between text-sm text-[#334155] mb-1" data-id="element-322">
                    <span data-id="element-323">{med.name}</span>
                    <span className="font-medium" data-id="element-324">
                      ${med.cost.toLocaleString()}
                    </span>
                  </div>
                  <div className="h-4 bg-[#F1F5F9] rounded-full overflow-hidden" data-id="element-325">
                    <div className="h-full bg-[#0EA5B7]" style={{
                  width: `${med.cost / maxCost * 100}%`
                }} data-id="element-326" />
                  </div>
                </div>)}
              <div className="pt-3 mt-3 border-t border-[#F1F5F9]" data-id="element-327">
                <div className="flex justify-between text-sm font-bold text-[#0F172A]" data-id="element-328">
                  <span data-id="element-329">Total Annual Cost:</span>
                  <span data-id="element-330">${totalCost.toLocaleString()}</span>
                </div>
                <div className="flex justify-between text-sm text-[#0EA5B7] mt-2" data-id="element-331">
                  <span data-id="element-332">iRelief Oculis-3:</span>
                  <span data-id="element-333">$179 (one-time)</span>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-6" data-id="element-334">
            <a href="https://irelief.us/products/vibration-bluetooth-eye-massager-visual-eye-massage-intelligent-eye-mask-massage-masajeador-heating-eyemask-face-facial-massager" className="block text-center bg-[#0EA5B7] hover:bg-[#0F172A] text-white font-medium py-3 px-4 rounded-md transition-colors text-sm" data-id="element-335">
              Explore a pill-free session
            </a>
          </div>
        </div>
      </div>
    </div>;
}